import React from 'react';
import styled from 'styled-components';

import { Icon } from '../icon';
import { useModalContext } from './context';
import { ModalHeaderProps } from './types';

import { ICONS } from '@controlrooms/constants';

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.modal.contentBackgroundColor};
  border-bottom: 1px solid ${({ theme }) => theme.modal.header.borderColor};
  border-radius: 4px 4px 0 0;
  padding: 11px 8px;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 19px;
  color: ${({ theme }) => theme.modal.header.headerTextColor};
`;

const SubtitleText = styled.div`
  margin-top: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: ${({ theme }) => theme.modal.header.subHeaderColor};
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.modal.footer.closeButton.color};
  cursor: pointer;
  padding: 3px;
  font-size: 11px;
  font-weight: 100;
  margin-left: auto;
  &:hover {
    color: ${({ theme }) => theme.timeDisplay.primaryTextHover};
  }
`;

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  subtitle,
  hideCloseButton: hideCloseButtonProp,
  children,
}) => {
  const { dismiss, hideCloseButton: hideCloseButtonCtx, loading } = useModalContext();
  const shouldHideClose = hideCloseButtonProp ?? hideCloseButtonCtx;

  if (children) {
    return (
      <StyledHeader>
        <HeaderRow>
          {children}
          {!shouldHideClose && (
            <CloseButton
              onClick={loading ? undefined : dismiss}
              aria-label="Close modal"
              data-testid="modal-close-button"
              disabled={loading}
            >
              <Icon name={ICONS.Close} width="10" height="10" />
            </CloseButton>
          )}
        </HeaderRow>
      </StyledHeader>
    );
  }

  return (
    <StyledHeader>
      <HeaderRow>
        {title && <TitleText>{title}</TitleText>}
        {!shouldHideClose && (
          <CloseButton
            onClick={loading ? undefined : dismiss}
            aria-label="Close modal"
            data-testid="modal-close-button"
            disabled={loading}
          >
            <Icon name={ICONS.Close} width="10" height="10" />
          </CloseButton>
        )}
      </HeaderRow>
      {subtitle && <SubtitleText>{subtitle}</SubtitleText>}
    </StyledHeader>
  );
};
